// Sunbeamstore – Hero Erlebniswelten
// Daten kommen aus Liquid (Single Source of Truth)

(function () {
  'use strict';

  const dataEl = document.getElementById('sbs-worlds-data');
  if (!dataEl) return;

  let worlds = [];
  try {
    worlds = JSON.parse(dataEl.textContent);
  } catch (err) {
    console.error('Sunbeamstore: Fehler beim Einlesen der Erlebniswelten.', err);
    return;
  }

  const card = document.getElementById('sbs-card');
  if (!card) return;

  const cardBild  = card.querySelector('.sbs-card__bild');
  const cardEmoji = card.querySelector('.sbs-card__emoji');
  const cardTitel = card.querySelector('.sbs-card__titel');
  const cardText  = card.querySelector('.sbs-card__text');
  const cardBtn   = card.querySelector('.sbs-card__btn');
  const cardClose = card.querySelector('.sbs-card__close');

  const worldsById = new Map(worlds.map(w => [w.id, w]));

  worlds.forEach(world => {
    if (!world.bild) return;
    const img = new Image();
    img.src = world.bild;
  });

  // ─── Hotspot-Positionierung ───────────────────────────────────────────────
  // Section-scoped: layerEl wird über den Shopify-Section-Wrapper gefunden,
  // nicht global – robust auch bei mehreren Hero-artigen Sections.

  function positionHotspots() {
    const heroEl  = document.querySelector('.hero-wrapper .hero');
    const layerEl = document.querySelector('.sbs-hotspot-layer');
    if (!heroEl || !layerEl) return;

    // Shopify rendert automatisch id="shopify-section-XYZ" auf dem <section>
    // closest() findet den zugehörigen Section-Wrapper eindeutig
    const sectionEl = layerEl.closest('[id^="shopify-section-"]');
    if (!sectionEl) return;

    // Sicherheitscheck: Layer gehört zur richtigen Section
    if (!sectionEl.contains(layerEl)) return;

    const heroRect  = heroEl.getBoundingClientRect();
    const layerRect = layerEl.getBoundingClientRect();

    const offsetTop  = heroRect.top  - layerRect.top;
    const offsetLeft = heroRect.left - layerRect.left;

    sectionEl.querySelectorAll('.sbs-hotspot').forEach(btn => {
      const world = worldsById.get(btn.dataset.id);
      if (!world) return;

      btn.style.left = (offsetLeft + (world.left / 100) * heroRect.width)  + 'px';
      btn.style.top  = (offsetTop  + (world.top  / 100) * heroRect.height) + 'px';
    });
  }

  // Initiale Berechnung – gecachte Seiten abfangen
  if (document.readyState === 'complete') {
    positionHotspots();
  } else {
    window.addEventListener('load', positionHotspots);
  }

  // Webfonts – Firefox verschiebt Layouts nach Font-Load minimal
  if (document.fonts) {
    document.fonts.ready.then(positionHotspots);
  }

  // Resize mit requestAnimationFrame
  let resizeScheduled = false;
  window.addEventListener('resize', () => {
    if (resizeScheduled) return;
    resizeScheduled = true;
    requestAnimationFrame(() => {
      positionHotspots();
      resizeScheduled = false;
    });
  });

  // Theme-Editor-Events
  document.addEventListener('shopify:section:load',    positionHotspots);
  document.addEventListener('shopify:section:reorder', positionHotspots);
  document.addEventListener('shopify:block:select',    positionHotspots);

  // ─── Card-Logik ───────────────────────────────────────────────────────────

  function openCard(world) {
    card.style.setProperty('--sbs-accent', world.farbe);
    cardBild.src          = world.bild  || '';
    cardBild.alt          = world.titel;
    cardEmoji.textContent = world.emoji || '';
    cardTitel.textContent = world.titel || '';
    cardText.textContent  = world.text  || '';
    cardBtn.href          = world.link  || '#';
    card.classList.add('is-open');
    card.setAttribute('aria-hidden', 'false');
  }

  function closeCard() {
    card.classList.remove('is-open');
    card.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('.sbs-hotspot').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const world = worldsById.get(btn.dataset.id);
      if (!world) return;
      if (card.classList.contains('is-open') && cardTitel.textContent === world.titel) {
        closeCard();
      } else {
        openCard(world);
      }
    });
  });

  cardClose.addEventListener('click', e => { e.stopPropagation(); closeCard(); });

  document.addEventListener('click', e => {
    if (!card.contains(e.target) && !e.target.closest('.sbs-hotspot')) closeCard();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCard();
  });

})();
